module.exports = __webpack_public_path__ + "img/04.60e66013.jpg";